exports.components = {
  "component---src-components-pages-home-home-tsx": () => import("./../../../src/components/pages/Home/Home.tsx" /* webpackChunkName: "component---src-components-pages-home-home-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

